module.exports = __webpack_public_path__ + "static/media/img_1_1685960901030.9617f857.jpg";